import { EnvironmentInjector, inject, Injectable, NgZone, runInInjectionContext } from '@angular/core';
import { Auth, authState,  getAuth, Unsubscribe, User, UserCredential, confirmPasswordReset, createUserWithEmailAndPassword, sendEmailVerification, sendPasswordResetEmail, signInWithEmailAndPassword, signOut, updatePassword, verifyPasswordResetCode} from '@angular/fire/auth';
import { Firestore,  docData, getDoc, docSnapshots, collectionSnapshots,  doc,  setDoc, updateDoc, query, where, collection, onSnapshot, getDocs, deleteDoc } from '@angular/fire/firestore';
import { } from 'firebase/auth';
import {} from 'firebase/firestore';
import { Store } from '@ngrx/store';
import { Observable, Subject, lastValueFrom, map, of, switchMap,  take,  takeUntil,  tap } from 'rxjs';
import { AuthUserActions, authUserFeature,  } from '../store/authUser.store';
import { AuthUser, COLLECTION_PATH_INVITES, COLLECTION_PATH_USERS, UserInvite} from '../../../globalTypes/auth.types';
import { Router } from '@angular/router';
// import { getDoc, QuerySnapshot } from 'firebase/firestore';
import { AccountActions } from '../store/account.store';
import { Logger } from '../helper/logger';
// import { getAuth } from 'firebase/auth';
import { activateMyUserStatus, ActivateMyUserStatusVariables, addSystemAsAUser, createMyUser, CreateMyUserVariables, insertMainSegments, insertMainStatuses, readMainStatus } from '@dataconnect/account';
import { MatSnackBar } from '@angular/material/snack-bar';
import { snackBarError } from '../helper/error.handling';
import { AccountService } from './account.service';
import { sleep } from '../../../globalTypes/_helpers';
const log = new Logger('AuthService');
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  userCollectionName = COLLECTION_PATH_USERS;
  inviteCollectionName = COLLECTION_PATH_INVITES ;
  inviteUnsub?: Unsubscribe

  public readonly authState$: Observable<User | null>;
  readonly currentUserData$: Observable<any | null>; 
  public readonly isLoggedIn$: Subject<boolean> = new Subject();
  public readonly roles$: Subject<string[]> = new Subject();
  user!: User
  envInjector = inject(EnvironmentInjector)
  
  // TODO VALIDATE EMAIL FLOW

  constructor(
    private auth: Auth,
    private db: Firestore,
    private router: Router,
    private snackBar: MatSnackBar,
    private accountService: AccountService,
    private readonly store: Store,
  ) { 
    
    this.authState$ = authState(this.auth);
    this.currentUserData$ = this.authState$.pipe(
        tap(user => log.log({currentUserData$: user})),
        switchMap((user)=>{
          if(user){
            log.log({user, email: user.email, verified: user.emailVerified});
            this.user = user;
            try {
              return runInInjectionContext(this.envInjector, ()=>{
                return docData(doc(this.db, this.userCollectionName + '/' + user.uid)); 
              })
            } catch(error:any){
              const errMsg = "Error retrieving user data"
              snackBarError(errMsg, this.snackBar);
              throw new Error(errMsg)
            }
        } else {
            return of(null);
          }
      })
    )

    // Now, subscribe to currentUserData$ once, or use it in your components via async pipe
    // Avoid making direct API calls within this subscribe for robustness
    this.currentUserData$.subscribe({
      next: async (userData) => {
        log.log({userData: userData});
        // dispatch NGRX actions here
        if (userData && userData.id) {
          // Dispatch action to update user state in store
          const existingUser = await lastValueFrom(this.store.select(authUserFeature.selectUser).pipe(take(1)));
          if(existingUser) {
            console.error({existingUserBeforeSetUser: existingUser})
            // return;
          }
          this.setUserAsAuthUser(userData);
        } else {
          // Dispatch action for logged out state or navigate
          this.setUserAsAuthUser(null)
        }
      },
      error: (err) => log.error('Error fetching user data:', err)
    });
  }

  getInitials(name: string): string { 
    const names = name.split(' ');
      if (names.length >= 2) {
        return names[0].charAt(0) + names[names.length - 1].charAt(0);
      } else if (names.length === 1) {
        return names[0].charAt(0);
      } else {
        return '--';
      }
  }

  async emailVerifiedCheck(){
    // FIXME Build out to do everything that is done in email-verified does
    await this.auth.currentUser?.reload();
    const isEmailVerified = this.auth.currentUser?.emailVerified;
    console.log({isEmailVerified})
    if(!!isEmailVerified && !!this.auth.currentUser){
      const updated: Pick<AuthUser, "id"> & Partial<AuthUser> = {
        id: this.auth.currentUser.uid || '',
        isEmailVerified: true,
      }
      console.log({updated})
      await this.saveUser(updated)
      const user = (await getDoc(doc(this.db, this.userCollectionName + '/' + this.auth.currentUser.uid))).data() as AuthUser;
      console.log({emailVerifiedCheckUser: user})
      await this.activateUserInDataConnect(user);
      return true;
    }
    return false;
  }

  async saveUser(newUser: Pick<AuthUser, 'id'> & Partial<AuthUser>){
    try{
      await runInInjectionContext(this.envInjector, async()=>{
        const userDocRef = doc(this.db, this.userCollectionName + '/' + newUser.id);
        if(newUser.displayName) newUser.initials = this.getInitials(newUser.displayName || '');
        await setDoc(userDocRef, newUser, {merge: true});
        console.log({savedUser: newUser})
      });
    } catch (error) {
      log.error({loc: "signup saveUser",newUser,error});
    }
  }

  async signUp(email:string, password: string): Promise<void> {
    // find user by email,
    try{
      this.store.dispatch(AuthUserActions.isLoading({isLoading: true}));
      // check invite exists first via http
      let user: User | null = null
        try {
          user = (await createUserWithEmailAndPassword(this.auth, email, password)).user;
        } catch (error) {
          throw error;
        }
      const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      const newUser: AuthUser = {
        id: user.uid,
        initials: this.getInitials(user.displayName || ''),
        displayName: user.displayName || '',
        email: user.email || '',
        mobile: user.phoneNumber || '',
        avatarUrl: user.photoURL || '',
        isEmailVerified: user.emailVerified || false,
        isVerifiedForSegment: {},
        lastLogin: Date.now(),
        preferences: { isDarkMode: isDarkMode },
      };
      log.log({newUser});
      // FIXME add displayname and phone to authorization account ??
    await sleep(1000);
      const statusRef = await readMainStatus();
      let insertInitiateSetup = false;
      console.log({statusRef})
      if(!statusRef || !statusRef.data || statusRef.data.statuses.length === 0){
        insertInitiateSetup = true;
        const initiateSetup = await insertMainStatuses();
        console.log({initiateSetup})
      }
      if(!statusRef || !statusRef.data || !statusRef.data.systemUsers || statusRef.data.systemUsers.length === 0){
        await addSystemAsAUser();
      }
      await this.saveUser(newUser);
      await this.saveInitUserToDataConnect(newUser);
      if(insertInitiateSetup){
        const insertSegments = await insertMainSegments();
        console.log({insertSegments})
      }
      if(user.emailVerified){
        await this.activateUserInDataConnect(newUser);
      }
      this.setUserAsAuthUser(user ? newUser : null);
      return 
    }catch(error:any){
      throw error;
    }
  }

  async setUserAsAuthUser(user: AuthUser | null): Promise<void>{
    // set user as AuthUser
    log.log({user});
    this.store.dispatch(AuthUserActions.setUser({user}));
    
    // Access the URL segments from the snapshot
    let needsRedirect = false
    let doNotRedirect = false
    const path = window.location.href.replace(window.location.origin, '');
    log.log({path});
    const redirectablePages = ['/login', '/signup']; //  '/listing/search'
    const nonRedirectablePages = ['/email-verified']
    if(redirectablePages.includes(path)){
      needsRedirect = true;
      log.log({needsRedirect});
    }
    if(nonRedirectablePages.includes(path)){
      doNotRedirect = true;
    }
    if(user && user.email){
  // TODO: Add a notification collection that can be connected to for the life of the site, then
  // put things like "you are invited to" on that.  Then you only have to make one subscription to
  // keep up to date
      
      let userUpdate: Pick<AuthUser, 'id'> & Partial<AuthUser> = {id: user.id}
      if(this.user.emailVerified ){ 
        if(!user.isEmailVerified){
          userUpdate.isEmailVerified = true;
        }
        this.connectToReceivedInvites(user.email);
        await sleep(100)
        await this.accountService.loadMyAccountInfo('setUserAsAuthUser');
      }
      if(!!this.user.displayName && this.user.displayName !== user.displayName){
        userUpdate.displayName = this.user.displayName;
      }
      if(!!this.user.phoneNumber &&this.user.phoneNumber !== user.mobile){
        userUpdate.mobile = this.user.phoneNumber;
      }
      if(Object.keys(userUpdate).length > 1){
        log.warn({location:'setUserAsAuthUser',userUpdate});
        await this.saveUser(userUpdate);
      }
      if(!user.isEmailVerified || !user.displayName || !user.defaultLocationId){
        if(!doNotRedirect) this.router.navigate(['/account/manage']);
        return;
      } 
      setTimeout(()=>{
        if(needsRedirect) this.router.navigate(['/listing/search']);
      }, 0)
    } else {
      if(needsRedirect) this.router.navigate(['/login']);
    }
  }

  connectToReceivedInvites(email: string){
    if(this.inviteUnsub) this.inviteUnsub();

    return runInInjectionContext(this.envInjector, ()=>{
      this.inviteUnsub = onSnapshot(
        query(
          collection(this.db, this.inviteCollectionName),
          where('email', '==', email),
          where('isActive', '==', true),         // Ensure the invite is active
          where('expiresAt', '>', Date.now()) // Check if the expiration date is in the future
        ),(snapshot) => {
          const userInvites: UserInvite[] = [];
          snapshot.forEach((doc) => {
            userInvites.push(doc.data() as UserInvite);
          });
          this.store.dispatch(AccountActions.setInvitationsReceived({invitationsReceived: userInvites}));
          log.log({userInvites});
        }
      );
    })
  }

  async saveInitUserToDataConnect(user: AuthUser){
    try{
      const vars: CreateMyUserVariables = {
        displayName: user.displayName,
        mobile: user.mobile,
      }
      // FIXME! on accept user invite, check that the inviter has permissions on the location before saving
      const userSaveRef = await createMyUser(vars);
      log.log({userSaveRef})
    } catch (error) {
      log.error({loc: "signup saveInitUserToDataConnect", user,error});
    }
  }

  async activateUserInDataConnect(user: AuthUser){
    try{
      const { displayName, mobile } = user;
      const activateMyUserStatusVars: ActivateMyUserStatusVariables = {displayName, mobile};
      console.log({activateMyUserStatusVars})
      return await activateMyUserStatus(activateMyUserStatusVars);
    } catch (error) {
      this.snackBar.open("Error activating user. Please contact support.", "Close", {duration: 5000}) 
      log.error({loc: "signup activateUserInDataConnect", error});
      throw new Error("Error in signup activateUserInDataConnect: "+error)
    }
  }

  async login(email: string, password: string): Promise<UserCredential> {
    this.store.dispatch(AuthUserActions.isLoading({isLoading: true}));

    return await runInInjectionContext(this.envInjector, async ()=>{
      return await signInWithEmailAndPassword(this.auth, email, password);
    })
  }

  async sendPasswordResetEmail(email: string): Promise<void>{
    return await sendPasswordResetEmail(this.auth, email);
  }

  async sendEmailVerificationLink(email: string): Promise<void>{
    return await runInInjectionContext(this.envInjector, async ()=>{
      const auth = getAuth();
      const user = auth.currentUser;
      const urlBase = window.location.origin; // window.location.hostname
      log.log({urlBase})
      return await sendEmailVerification(user as User, {url: urlBase + "/email-verified?email="+email});
    })
  }


  async verifyPasswordResetCode(code: string): Promise<string>{
    return await verifyPasswordResetCode(this.auth, code);
  }

  async confirmPasswordReset(code: string, password: string): Promise<void>{
    return await confirmPasswordReset(this.auth, code, password);
  }

  async updateUserPassword(password: string): Promise<boolean>{
    const user = this.auth.currentUser;
    if(!user) return false;
    await updatePassword(user, password);
    return true;
  }

  async updateLastLoggedIn(id: string): Promise<void>{
    try {
      // TODO: should be in sql
      return await runInInjectionContext(this.envInjector, async ()=>{
        return await updateDoc(doc(this.db, this.userCollectionName + '/' + id), {lastLogin: Date.now()})
      })
    } catch(error){ 
      throw new Error("Error updating last login")
    }
  }

  logout(email?: string): void{
    this.store.dispatch(AuthUserActions.setUser({user: null}))
    if(this.inviteUnsub) this.inviteUnsub();
    runInInjectionContext(this.envInjector, () => {
      signOut(this.auth);
    })
    const route = email ? ['/login', {email}] : ['/login'];
    this.router.navigate(route);
  }

  connectToInvitationsSentUntil(destroy$: Subject<boolean>): Observable<UserInvite[]>{
    return runInInjectionContext(this.envInjector, ()=>{
      return collectionSnapshots(query(collection(this.db, this.inviteCollectionName),
        where('invitedById', '==', this.auth.currentUser?.uid),
      )).pipe(
        takeUntil(destroy$), // Good practice for component cleanup
        map((snapshots)=>{
          const userInvites: UserInvite[] = [];
          snapshots.forEach((snapshot)=>{
            userInvites.push(snapshot.data() as UserInvite);
          })
          this.store.dispatch(AccountActions.setInvitationsSent({invitationsSent: userInvites}));
          log.log({userInvites});
          return userInvites;
        })
      );
    });
  }

  async saveInvite(inviteData: {email: string, segmentId: string, locationName: string, locationId: string, message?: string, locationImageURL?: string}){
    const authUser = await lastValueFrom(this.store.select(authUserFeature.selectUser).pipe(take(1)))
    // FIXME! authorize: check if user is allowed on the location they are inviting too... maybe needs to be a function?
    const {email, segmentId, locationName, locationId, message, locationImageURL} = inviteData;
    if(authUser){
      const invite: UserInvite = {
        email,
        message,
        invitedToSegmentId: segmentId,
        invitedToLocationId: locationId,
        isActive: true,
        expiresAt: Date.now() + 86400000 * 30,
        invitedBy: authUser.displayName+" from "+ locationName,
        invitedById: authUser.id,
        createdAt: Date.now(),
      }
      if(locationImageURL){
        invite.invitedByImageURL = locationImageURL;
      }
      log.log({invite})
      runInInjectionContext(this.envInjector, async ()=>{
        let recordId = '';
        const inviteDocRef = query(collection(this.db, this.inviteCollectionName),
          where('email', '==', email),
          where('invitedToLocationId', '==', locationId), // Check for existing invites to the same location or no specified location
          where('invitedById', '==', authUser.id),
        );
        const snapshot = await getDocs(inviteDocRef)
        if(!snapshot) return;
        log.log({snapshot});
        snapshot.size
        if(snapshot.size){
          snapshot.forEach((doc) => {
            const locationInvite = doc.data() as UserInvite;
            if(locationInvite){
              if(locationInvite.respondedAt){
                if(!locationInvite.accepted){
                  throw Error('This user has already declined the invite by '+locationInvite.invitedBy+". Please delete the existing invite and try again.");
                }
                if(locationInvite.accepted){
                  throw Error('This user has already accepted the invite by '+locationInvite.invitedBy+" on "+ locationInvite.respondedAt +".");
                }
              }
            }
            // If the invite exists and is active, delete it before creating a new one
            deleteDoc(doc.ref);
          });
        }
        const inviteRef = recordId ? doc(this.db, this.inviteCollectionName + '/' + recordId) : doc(collection(this.db, this.inviteCollectionName))
        invite.id = inviteRef.id;
        await setDoc(inviteRef, invite); // onCreateInvitation picks up the new invite and sends the email
        
      })
      
    }
  }
}
